<template>
  <notification-list :isTestPortal="true"></notification-list>
</template>
<script>
import notificationList from "./notification-list";
export default {
  name: "test-portal-notification-list",
  components: {
    notificationList
  }
};
</script>
